import { kea } from 'kea'
import { put } from 'redux-saga/effects'
import PropTypes from "prop-types";
import { get } from 'lodash'

import entities from '~/entities'
import { Contacts } from '@gratify-eu/entities'

import rootLogic from '~/scenes/logic'

export default kea({
  path: () => ['scenes', 'summary'],

  connect: {
    actions: [
      rootLogic, [
        'next',
        'navigate'
      ]
    ],
    values: [
      rootLogic, [
        'loading',
        'shippingRequired'
      ],
      entities, [
        'activeCart',
        'shopPaymentMethods',
        'shopShippingMethods',
      ]
    ]
  },

  actions: () => ({
    setTermsCheckbox: (checked) => ({checked}),
  }),

  reducers: ({ actions, constants }) => ({
    termsChecked: [false, PropTypes.bool, {
      [actions.setTermsCheckbox]: (_, payload) => (!!payload.checked),
    }]
  }),

  selectors: ({ constants, selectors }) => ({
    mustAgreeTerms: [
      () => [
        entities.selectors.activeShop
      ], (activeShop) => {
        return get(activeShop, 'checkout_settings.must_agree_to_sales_terms', false);
      },
      PropTypes.bool
    ],
    termsLink: [
      () => [
        entities.selectors.activeShop
      ], (activeShop) => {
        let termsLink = get(activeShop, 'checkout_settings.terms_link', null);
        if(termsLink) {
          try {
            termsLink = new URL(termsLink);
            termsLink.searchParams.set('hidegfy', '1')
            termsLink = termsLink.toString();
          } catch(e) {

          }
        }
        return termsLink;
      },
      PropTypes.string
    ],
    allowContinue: [
      () => [
        selectors.mustAgreeTerms,
        selectors.termsChecked,
      ], (mustAgree, checked) => {
        if(mustAgree) {
          return checked;
        }

        return true
      },
      PropTypes.bool
    ],
    contact: [
      () => [
        entities.selectors.activeCart,
        entities.selectors.contacts,
      ], (activeCart, contacts) => {
        if(activeCart && activeCart.contact && contacts) {
          const contact = contacts[activeCart.contact];

          if(contact) {
            return contact;
          }
        }

        return null;
      },
      PropTypes.object
    ],
    shippingContact: [
      () => [
        entities.selectors.activeCart,
        entities.selectors.contacts,
      ], (activeCart, contacts) => {
        if(activeCart && activeCart.shipping_contact && contacts) {
          const contact = contacts[activeCart.shipping_contact];

          if(contact) {
            return contact;
          }
        }

        return null;
      },
      PropTypes.object
    ]
  }),

  start: function * () {
    const activeCart = yield entities.get('activeCart');
    const shippingRequired = yield this.get('shippingRequired');

    if(activeCart) {
      if(activeCart.contact) {
        const contact = yield this.get('contact');

        if(!contact) {
          yield put(Contacts.actions.fetch.request(null, null, activeCart.contact));
        }
      }

      if(shippingRequired && activeCart.shipping_contact && activeCart.shipping_contact !== activeCart.contact) {
        const shippingContact = yield this.get('shippingContact');

        if(!shippingContact) {
          yield put(Contacts.actions.fetch.request(null, null, activeCart.shipping_contact));
        }
      }
    }

    console.log('cart', activeCart);
  }
})
